<template>
  <div class="pageArea">
    <Head2></Head2>
    <div class="mainArea">
      <div class="mainInner">
        <!-- <div class="mainTitle">首页<span>></span>最新信息<span>></span>查看更多</div> -->
        <div class="mainTitle" v-if="type == 'LATEST'">{{ $t("pages.info.breadcrumb") }}</div>
        <div class="mainTitle" v-if="type == 'IMPORTANT'">{{ $t("pages.info.breadcrumb2") }}</div>

        <div class="lists">
          <!-- <div class="listTitle"><div class="listLine"></div>最新消息</div> -->
          <div class="listTitle" v-if="type == 'LATEST'">
            <div class="listLine"></div>{{ $t("components.foot2.latestInfo") }}
          </div>
          <div class="listTitle" v-if="type == 'IMPORTANT'">
            <div class="listLine"></div>{{ $t("components.foot2.importantNotice") }}
          </div>
          <div class="layout" v-for="item in currentPageList" :key="item.id">
            <router-link :to="{ path: '/info', query: { id: item.id } }">
              <div class="title">{{ item.title }}</div>
              <div class="date">发布时间：{{ item.gmt_create }}</div>
            </router-link>
          </div>
        </div>
        <div class="pagenations">
          <div class="pageDot" :class="{ 'active': index + 1 == currentPage }" v-for="(item, index) in totalPages"
            :key="index" @click="changePage(index + 1)">
            {{ index + 1 }}
          </div>
          <div class="pageDot" @click="nextPage">下一页>></div>
        </div>
      </div>
    </div>
    <Foot2></Foot2>
  </div>
</template>

<script>
import Head2 from "../components/head2.vue";
import Foot2 from "../components/foot2.vue";

export default {
  components: {
    Head2,
    Foot2,
  },
  data() {
    return {
      type: '',
      latestArtList: [],
      importArtList: [],
      currentPage: 1,
      pageSize: 11,
      totalCount: 0,
      totalPages: 0,
    };
  },
  created() {
    // 从路由参数中获取 type
    if (this.$route.query.type) {
      this.type = this.$route.query.type;
    }
    if (this.type == 'LATEST') {
      this.getLatestArticleInfo();
    } else if (this.type == 'IMPORTANT') {
      this.getImportArticleInfo();
    }
  },
  computed: {
    currentPageList() {
      let list = this.type == 'LATEST' ? this.latestArtList : this.importArtList;
      let startIndex = (this.currentPage - 1) * this.pageSize;
      let endIndex = startIndex + this.pageSize;
      return list.slice(startIndex, endIndex);
    }
  },
  methods: {
    changePage(page) {
      if (page < 1 || page > this.totalPages) return;
      this.currentPage = page;
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    getLatestArticleInfo() {
      this.$scUtil.axiosPost(
        this,
        "ArticleApi/GetArticleListByTypePageList",
        {
          articleType: "normal",
          pageIndex: this.currentPage,
          pageSize: this.pageSize
        },
        (res) => {
          if (res.Total > 0) {
            res.Data.forEach((item) => {
              item.gmt_create = this.$scUtil.dateFormatter(
                new Date(item.gmt_create),
                "Y/M/D"
              );
            });
          }

          this.latestArtList = res.Data || [];
          this.totalCount = res.Total || 0;
          this.totalPages = Math.ceil(this.totalCount / this.pageSize);
          this.currentPage = 1;
          // console.log("最新消息", this.latestArtList);
        }
      );
    },
    getImportArticleInfo() {
      this.$scUtil.axiosPost(
        this,
        "ArticleApi/GetArticleListByTypePageList",
        {
          articleType: "import",
          pageIndex: this.currentPage,
          pageSize: this.pageSize
        },
        (res) => {
          if (res.Total > 0) {
            res.Data.forEach((item) => {
              item.gmt_create = this.$scUtil.dateFormatter(
                new Date(item.gmt_create),
                "Y/M/D"
              );
            });
          }

          this.importArtList = res.Data || [];
          this.totalCount = res.Total || 0;
          this.totalPages = Math.ceil(this.totalCount / this.pageSize);
          this.currentPage = 1;
          // console.log("重要通知", this.importArtList);
        }
      );
    },
  },
  watch: {
    // 监听路由变化，以防在同一个页面内切换类型
    '$route'(to, from) {
      if (to.query.type) {
        this.type = to.query.type;
        // 重新获取数据
        if (this.type == 'LATEST') {
          this.getLatestArticleInfo();
        } else if (this.type == 'IMPORTANT') {
          this.getImportArticleInfo();
        }
      }
    },
  },
};
</script>

<style scoped>
.mainArea {
  background: #ebecee;
  width: 100%;
  display: flex;
  justify-content: center;
}

.mainInner {
  width: 1210px;
  margin-bottom: 31px;
  box-sizing: border-box;

}
.mainTitle {
  font-size: 13px;
  color: #333333;
  background: #ebecee;
  padding: 14px 42px 14px 0px;
}
.mainTitle span {
  margin: 0 13px 0 9px;
}

.listTitle {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #000;
  height: 59px;
  border-bottom: 1px solid #e2e2e2;
}

.lists {
  padding: 0 30px 26px 30px;
  box-sizing: border-box;
  background: #fff;
}

.listLine {
  width: 4px;
  height: 15px;
  background: #0380fe;
  margin-right: 14px;
}

.layout {
  width: 100%;
  min-height: 86px;
  border-bottom: 1px solid #e2e2e2;
  padding: 0 24px;
  box-sizing: border-box;
  line-height: 25px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.layout:hover {
  background: #ebf5ff;
}

.title {
  font-size: 13px;
  color: #000;
}

.date {
  font-size: 12px;
  color: #888888;
}

.pagenations {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 26px 0 0 0;
}

.pageDot {
  white-space: nowrap;
  padding: 5px 14px;
  font-size: 13px;
  color: #0380fe;
  background: #fff;
  border: 1px solid #9b9b9b;
  margin-right: 12px;
}

.pageDot:nth-last-child(1) {
  margin-right: 0rpx;
}

.pageDot:hover,
.pageDot.active {
  background: #0380fe;
  color: #fff;
}
</style>